import { SmoothScroll } from "@/components/SmoothScroll";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { HowItWorks } from "@/components/site/HowItWorks";
import { RecentJobs } from "@/components/site/RecentJobs";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

export default function LandingPage() {
  return (
    <SmoothScroll>
      <div className="bg-cream" data-testid="landing-page">
        <Nav />
        <main>
          <Hero />
          <Marquee />
          <HowItWorks />
          <RecentJobs />
          <Contact />
        </main>
        <Footer />
      </div>
    </SmoothScroll>
  );
}
